import { PnlAttributions } from '@fortem-monorepo/web-sdk'

export const POSITION_COMPONENT_TYPES = {
  ACCRUAL: 'ACCRUAL',
  CARRY: 'CARRY',
  CASHFLOW: 'CASHFLOW',
  FEE: 'FEE',
  ADJUSTMENT: 'ADJUSTMENT',
  OTHER: 'OTHER',
  RESET: 'RESET',
  DIVIDEND: 'DIVIDEND',
} as const satisfies Record<PnlAttributions.PositionComponentType, string>

export const ALLOCATION_RULES = {
  SIGNED_QUANTITY_NOTIONAL_PRO_RATA: 'SIGNED_QUANTITY_NOTIONAL_PRO_RATA',
} as const satisfies Record<PnlAttributions.AllocationRule, string>

export const attributionTypeBadgeClassnames: Record<PnlAttributions.AttributionType, string> = {
  existing: 'border border-blue-300 bg-blue-100 text-blue-600 text-xs uppercase tracking-wide text-[11px] px-1.5 py-px',
  new: 'border border-purple-300 bg-purple-100 text-purple-600 text-xs uppercase tracking-wide text-[11px] px-1.5 py-px',
  maturing:
    'border border-amber-300 bg-amber-100 text-amber-600 text-xs uppercase tracking-wide text-[11px] px-1.5 py-px',
  reference:
    'border border-cyan-300 bg-cyan-100 text-cyan-600 text-xs uppercase tracking-wide text-[11px] px-1.5 py-px',
}
